module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/BT-6e528abf9349d338b74eda5cdcb9bb97.png";